export default __webpack_public_path__ + "static/media/quote-2.8e78aae1.webp";